// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageResizerAndCropper__root___3yO_f","roundedCropArea":"ImageResizerAndCropper__roundedCropArea___YPYiF"};